'use client';

import { Swiper, SwiperSlide } from "swiper/react";
import { Pagination } from "swiper/modules";
// import "swiper/css";
// import "swiper/css/pagination";

const CARDS = [
  {
    id: 1,
    title: "No Payroll Mandate for Employees",
    desc: "Candidates are treated as trainees or apprentices without payroll obligations for your organization.",
    img: "https://cdn.msu.edu.in/partner/partner-4.webp",
  },
  {
    id: 2,
    title: "UGC-approved degree/diploma",
    desc: "UGC-recognized degree and diploma programs that support long-term career advancement for learners.",
    img: "https://cdn.msu.edu.in/partner/partner-5.webp",
  },
  {
    id: 3,
    title: "NCVET approved Certification",
    desc: "NCVET-approved skill certification to validate industry-relevant skills and enhance employability.",
    img: "https://cdn.msu.edu.in/partner/partner-6.webp",
  },
  {
    id: 4,
    title: "Industry-Aligned Curriculum",
    desc: "Programs co-developed with industry partners to ensure practical, hands-on training.",
    img: "https://cdn.msu.edu.in/partner/partner-1.webp",
  },
];

export function WhyPartnerCarousel() {
  return (
    <section className="relative py-14 md:py-16 bg-gradient-to-b from-white via-slate-50 to-white">
      <div className="max-w-[var(--max-page-width)] px-[var(--container-padding)] mx-auto text-center">
        
        {/* Heading */}
        <p className="text-[11px] md:text-xs uppercase tracking-[0.25em] text-slate-400 mb-2">
          Partnership Advantage
        </p>
        <h2 className="text-2xl md:text-3xl lg:text-4xl font-semibold text-slate-900 mb-3">
          Why Partner with Us?
        </h2>
        <p className="text-sm md:text-base text-slate-500 mb-10 md:mb-12 max-w-2xl mx-auto">
          Empowering industries with future-ready talent and tailored skilling solutions.
        </p>

        {/* Carousel Container */}
        <div className="rounded-[32px] p-5 py-8  md:p-8">
          <Swiper
            modules={[Pagination]}
            spaceBetween={24}
            pagination={{ clickable: true }}
            slidesPerView={1}
            breakpoints={{
              640: { slidesPerView: 1.2 },
              768: { slidesPerView: 2 },
              1024: { slidesPerView: 2.5 },
              1280: { slidesPerView: 3 },
            }}
            className="pb-10"
          >
            {CARDS.map((card) => (
              <SwiperSlide key={card.id}>
                <Card item={card} />
              </SwiperSlide>
            ))}
          </Swiper>
        </div>

      </div>
    </section>
  );
}

function Card({ item }) {
  return (
    <article className="group h-full rounded-[28px] overflow-hidden bg-white border border-slate-100 shadow-sm transition-all duration-300 hover:-translate-y-2 mb-2">
      
      {/* Image */}
      <div className="relative w-full aspect-[4/3] overflow-hidden">
        <img
          src={item.img}
          alt={item.title}
          className="w-full h-full object-cover transition-transform duration-300 group-hover:scale-[1.04]"
        />
      </div>

      {/* Content */}
      <div className="px-5 md:px-6 py-4 md:py-5 text-left">
        <h3 className="text-base md:text-lg font-semibold text-slate-900 mb-2">
          {item.title}
        </h3>
        <p className="text-sm text-slate-500 leading-relaxed">
          {item.desc}
        </p>
      </div>
    </article>
  );
}
